export const redirectLinks = [
  { text: `Início`, anchor: `home` },
  { text: `Áreas`, anchor: `areas` },
  { text: `Contato`, anchor: `contact` },
];
